module.exports = __webpack_public_path__ + "img/type3.aaa47201.png";